import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { HomeIcon, SearchXIcon, ArrowLeftIcon } from 'lucide-react';
import Button from '../components/common/Button';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/common/Footer';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4"
    >
      <Helmet>
        <title>Page Not Found | VoiceVision</title>
        <meta name="description" content="The page you're looking for doesn't exist or has been moved." />
      </Helmet>
      <div className="text-center max-w-md">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8"
        >
          <div className="relative">
            <div className="text-9xl font-bold bg-gradient-to-br from-primary-300 to-primary-500 text-transparent bg-clip-text">404</div>
            <SearchXIcon className="h-24 w-24 text-primary-400 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-20" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mt-4">Page Not Found</h1>
          <p className="text-gray-600 mt-2">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </motion.div>
        
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            leftIcon={<ArrowLeftIcon className="h-5 w-5" />}
            className="w-full mb-4"
          >
            Go Back
          </Button>
          
          <Link to="/" className="block">
            <Button
              variant="primary"
              leftIcon={<HomeIcon className="h-5 w-5" />}
              className="bg-gradient-to-r from-secondary-500 to-primary-500 hover:from-secondary-600 hover:to-primary-600 shadow-lg hover:shadow-xl transition-shadow"
              fullWidth
            >
              Back to Home
            </Button>
          </Link>
        </motion.div>
        
        <div className="mt-16">
          <Footer />
        </div>
      </div>
    </motion.div>
  );
};

export default NotFound;